import { cloneElement, isValidElement, ReactElement } from 'react'
import { Box } from '@mui/material'
import { getClimateHazardVisualMeta } from './hazardConfig'

type ClimateHazardIconProps = {
  hazardCode?: string | null
  size?: number
  iconSize?: number
  borderRadius?: number | string
}

type IconElementProps = {
  sx?: unknown
}

const ClimateHazardIcon = ({ hazardCode, size = 28, iconSize = 20, borderRadius = '50%' }: ClimateHazardIconProps) => {
  const meta = getClimateHazardVisualMeta(hazardCode)
  const icon = isValidElement<IconElementProps>(meta.icon)
    ? cloneElement(meta.icon as ReactElement<IconElementProps>, {
        sx: [meta.icon.props.sx, { fontSize: iconSize }],
      })
    : meta.icon

  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius,
        backgroundColor: meta.accent,
        color: meta.tone,
        display: 'inline-grid',
        placeItems: 'center',
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
  )
}

export default ClimateHazardIcon
